import { render, staticRenderFns } from "./newSpell.vue?vue&type=template&id=08ead0e5&scoped=true"
import script from "./newSpell.vue?vue&type=script&lang=js"
export * from "./newSpell.vue?vue&type=script&lang=js"
import style0 from "./newSpell.vue?vue&type=style&index=0&id=08ead0e5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ead0e5",
  null
  
)

export default component.exports